import { AdminLayout } from '@/components/layouts'
import { useForm } from '@inertiajs/react'
import BadgeForm from './BadgeForm'

interface BadgeDetail {
  id: number
  slug: string
  name: string
  description: string | null
  emoji: string
  category: string
  condition_type: string | null
  condition_value: Record<string, unknown>
  points_reward: number
  community_id: number | null
  community_name: string | null
  created_at: string
  updated_at: string
}

interface Community {
  id: number
  name: string
}

interface ConditionType {
  value: string
  label: string
}

interface EditProps {
  badge: BadgeDetail
  categories: string[]
  communities: Community[]
  condition_types: ConditionType[]
}

export default function Edit({ badge, categories, communities, condition_types }: EditProps) {
  const form = useForm({
    name: badge.name,
    description: badge.description || '',
    emoji: badge.emoji,
    category: badge.category,
    community_id: badge.community_id?.toString() || '',
    points_reward: badge.points_reward.toString(),
    condition_type: badge.condition_type || '',
    condition_value: badge.condition_value || {}
  })

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    form.patch(`/admin/badges/${badge.slug}`)
  }

  return (
    <AdminLayout
      title={`Modifier ${badge.name}`}
      breadcrumbs={[
        { label: 'Badges', href: '/admin/badges' },
        { label: badge.name, href: `/admin/badges/${badge.slug}` },
        { label: 'Modifier' }
      ]}
    >
      <BadgeForm
        data={form.data}
        setData={form.setData}
        errors={form.errors}
        processing={form.processing}
        onSubmit={handleSubmit}
        categories={categories}
        communities={communities}
        conditionTypes={condition_types}
        submitLabel="Enregistrer les modifications"
        cancelHref={`/admin/badges/${badge.slug}`}
      />
    </AdminLayout>
  )
}
